import React from "react";
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, canonicalUrl }) => {
  const defaultTitle = "Solutions Langues Québec – Cours de Français & Examens";
  const defaultDesc = "Solutions Langues Québec propose des cours de français en ligne et sur place, ainsi que la préparation aux examens TEFAQ, TEF, TCF et DELF/DALF.";
  const defaultKeywords = "cours de français, TEF, TCF, TEFAQ, apprendre le français, Solutions Langues";

  return (
    <Helmet>
      <title>{title ? `${title} | Solutions Langues` : defaultTitle}</title>
      <meta name="description" content={description || defaultDesc} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl || "https://solutionslangues.com/"} />
      {/* Balises Open Graph / Réseaux Sociaux par défaut */}
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={description || defaultDesc} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
};

export default SEO;
